module.exports = __webpack_public_path__ + "img/COSTELA DO DIANTEIRO.7aac308c.jpg";